import { useState, useMemo, useEffect } from "react";
import { styled } from "@mui/material";
import { useTeamsUserCredential } from "@microsoft/teamsfx-react";
import { SubdomainStep } from "./Subdomain";
import { Loading } from "./sample/Loading";
import { useStore } from "../utils/useStore";
import config from "./sample/lib/config";
import { useTranslation } from "react-i18next";

const StyledIframe = styled("iframe")({
  border: 0,
  backgroundColor: "#fff",
});

export const Iframe = ({ url }) => {
  const { t } = useTranslation();
  const { subdomain, oneTimeToken, error, isLoggedIn, status, setStatus } = useStore();

  const [loading, setLoading] = useState(true);
  const { context } = useTeamsUserCredential({
    initiateLoginEndpoint: config.initiateLoginEndpoint,
    clientId: config.clientId,
  });

  const prefferedLanguage = useMemo(
    () => ((context?.app?.locale || "").includes("de-") ? "de" : "en"),
    [context?.app?.locale]
  );

  const domain = useMemo(() => {
    if (process.env.REACT_APP_DOMAIN) {
      return process.env.REACT_APP_DOMAIN;
    }
    return window.location.hostname === "localhost"
      ? "http://localhost:5173"
      : "https://" + subdomain;
  }, [subdomain]);

  const source = useMemo(() => {
    return (
      `${domain}/#/login?` +
      `redirectTo=${encodeURIComponent("/" + url)}&` +
      `ott=${oneTimeToken}&` +
      `subdomain=${encodeURIComponent(subdomain)}&` +
      `prefferedLanguage=${prefferedLanguage}`
    );
  }, [domain, oneTimeToken, subdomain, prefferedLanguage, url]);

  useEffect(() => {
    if (oneTimeToken || isLoggedIn) {
      setStatus(t("status.loadingIframe"));
    }
  }, [t, setStatus, oneTimeToken, isLoggedIn]);

  if (subdomain) {
    return (
      <>
        {(loading || error) && <Loading error={error} status={status} />}
        {(oneTimeToken || isLoggedIn) && (
          <StyledIframe src={source} height="100%" width="100%" onLoad={() => setLoading(false)} />
        )}
      </>
    );
  }
  return <SubdomainStep />;
};
